import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/htg-incentive'
const QUERY_KEY = 'htg-incentive'

export const useGetHtgIncentives = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, query],
    async () => (await API.get(serializeQuery(ENDPOINT, query))).data,
    config,
  )

export const usePostHtgIncentive = (config = {}) =>
  useMutation((newData) => API.post(ENDPOINT, newData), config)

export const usePatchHtgIncentive = (config = {}) =>
  useMutation((updatedData) => API.patch(ENDPOINT, updatedData), config)

export const useDeleteHtgIncentive = (config = {}) =>
  useMutation((id) => API.delete(ENDPOINT, { data: id }), config)
